import { HTMLAttributes, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import { Heart } from 'lucide-react'

// import SVGIcon from './svg-icon'
import { cn } from '@/lib/utils'

export type HeartIconProps = HTMLAttributes<HTMLSpanElement> & {
  active: boolean
}

const HeartIcon = ({ className, active, ...props }: HeartIconProps) => {
  const root = useRef<HTMLSpanElement>(null!)
  const timeline = useRef<GSAPTimeline>(null!)

  useGSAP(
    ({ selector }) => {
      if (!active) return

      const count = 8
      const step = 360 / count
      const particles = selector?.('[data-particles]')[0]

      const clearAnimation = () => {
        timeline.current?.kill()
        timeline.current?.clear()
        particles.innerHTML = ''
      }

      const createDot = () => {
        const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle')
        circle.setAttribute('cx', '50')
        circle.setAttribute('cy', '50')
        circle.setAttribute('r', '4')
        circle.setAttribute('fill', 'currentColor')
        return circle
      }

      clearAnimation()

      timeline.current = gsap.timeline()

      for (let i = 0; i < count; i++) {
        const deg = i * step
        const dot = createDot()
        particles.appendChild(dot)

        timeline.current.to(
          dot,
          {
            physics2D: {
              gravity: 0,
              velocity: 120,
              angle: deg
            },
            opacity: 0.2,
            ease: 'expo.inOut',
            transformOrigin: '50% 50%',
            duration: 0.6,
            scale: 0,
            onComplete: () => {
              particles.removeChild(dot)
            }
          },
          0
        )
      }

      return () => {
        clearAnimation()
      }
    },
    { scope: root, dependencies: [active], revertOnUpdate: false }
  )

  return (
    <span ref={root} className={cn('relative', className)} {...props}>
      <svg
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute left-1/2 top-1/2 size-[3.4rem] -translate-x-1/2 -translate-y-1/2"
        data-particles
      />
      <Heart
        size={16}
        strokeWidth="1"
        className={cn('fill-transparent', 'transition-colors duration-300 ease-out-cubic', {
          'fill-current': active
        })}
      />
      {/* <SVGIcon
        symbol="heart"
        className={cn('size-[1.6rem]', 'transition-colors duration-300 ease-out-cubic', {
          'fill-current': active
        })}
      /> */}
    </span>
  )
}

export default HeartIcon
